import { Checkbox, Loader } from '@randstad-lean-mobile-factory/react-components-core';

import { useToggleRoute } from 'src/Hooks/MbapiAdmin/useToggleRoute';

import { RouteCheckboxProps } from './RouteCheckbox.types';

export const RouteCheckbox = ({ route, username }: RouteCheckboxProps) => {
  const toggleRoute = useToggleRoute();

  return toggleRoute.isLoading ? (
    <Loader size="xsmall" />
  ) : (
    <div onClick={() => toggleRoute.mutate({ route, username })}>
      {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
      <Checkbox checked={route.usernames.includes(username)} onChange={() => {}} />
    </div>
  );
};
